import React, { useMemo, useState, useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
import {
  TextField,
  Select,
  MenuItem,
  IconButton,
  Menu,
  Switch,
  ListItemIcon,
  ListItemText,
  Button,
  Box,
} from "@mui/material";
import {
  TextBoxField,
  AutoCompleteField,
  MultiSelectField,
  SelectField,
  DateField,
  CheckboxField,
} from "../../components/newFrame/dynamic";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import ImageIcon from "@mui/icons-material/Image";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import DeleteIcon from "@mui/icons-material/Delete";
import HideSourceIcon from "@mui/icons-material/HideSource";
import ClearIcon from "@mui/icons-material/Clear";
import Battery0BarIcon from "@mui/icons-material/Battery0Bar";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { mkConfig, generateCsv, download } from "export-to-csv";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddIcon from "@mui/icons-material/Add";

//import { ExportToCsv } from "export-to-csv";
const MaterialTable = ({
  columns = [], // Add default empty array
  data = [], // Add default empty array
  onEdit,
  onView,
  onDelete,
  onSwitch,
  printTitle,
  actions = false, // Add default value
  selection = false, // Add default value
  selectedData = [], // Add default value
  setSelectedData = () => {}, // Add default empty function
  enableRowActions = false,
  positionActionsColumn = "first",
  switchParams = { key: "status", value: "Active" },
  setImageSrc,
  imageSrc,
  toolbar, // Add this prop
}) => {
  const [anchorEl, setAnchorEl] = React.useState({});
  const buttonStyles = {
    backgroundColor: "#601EF9",
    color: "white",
    "&:hover": {
      backgroundColor: "#601EF9",
    },
  };

  // const [selectedData, setSelectedData] = React.useState([]);
  const [showWebCam, setShowWebCam] = React.useState({});
  const [rowData, setRowData] = React.useState([]);
  // Add dynamic ID to each row
  const dataWithId = React.useMemo(() => {
    if (!Array.isArray(data)) return [];
    return data.map((row, index) => ({
      ...row,
      dynamicId: index,
    }));
  }, [data]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const handleClick = (event, id) => {
    setAnchorEl((prev) => ({
      ...prev,
      [id]: event.currentTarget,
    }));
  };

  const handleClose = (id) => {
    setAnchorEl((prev) => ({
      ...prev,
      [id]: null,
    }));
  };
  const webcamRef = React.useRef(null);
  // const [imageSrc, setImageSrc] = React.useState(null);
  const handleCaptureImage = (columnName, index) => {
    captureImage(columnName, index);
    setShowWebCam((prevImages) => ({
      ...prevImages,
      [`${columnName}-${index}`]: false,
    }));
  };
  const captureImage = (columnName, index) => {
    const imageSrc = webcamRef?.current?.getScreenshot();
    setImageSrc((prevImages) => ({
      ...prevImages,
      [`${columnName}-${index}`]: imageSrc,
    }));
  };

  const handleExportData = (title) => {
    const csvConfig = mkConfig({
      fieldSeparator: ",",
      decimalSeparator: ".",
      useKeysAsHeaders: true,
      filename: title || "exported_data",
    });
    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
  };
  const processColumns = useMemo(() => {
    return columns
      .map((col) => {
        if (col.field?.toLowerCase() === "id") {
          return null;
        }
        if (col.field) {
          <div style={{ textAlign: "center" }}>{col.field}</div>;
        }
        const baseColumn = {
          accessorKey: col.field,
          header: col.title,
          minSize: 40,
          maxSize: 80,
          enableSorting: true,
          enableColumnFilter: true,
          Cell: ({ row, cell }) => {
            // console.log(row, "row");
            // console.log(cell, "cell");
            const value = cell.getValue();
            const field = col.field;

            // Handle different value types
            if (typeof value === "object") {
              return JSON.stringify(value);
            }

            if (typeof value === "boolean") {
              return String(value);
            }

            // Handle special field types
            if (field.startsWith("qty_status")) {
              const highlightStyle =
                value === "unmatched"
                  ? { backgroundColor: "#FFD700", color: "#000" }
                  : {};
              return <div style={highlightStyle}>{value}</div>;
            }

            // Handle text alignment
            if (typeof value === "string") {
              const textAlign = field.toLowerCase().includes("asn_quantity")
                ? "right"
                : "left";
              return <div style={{ textAlign }}>{value}</div>;
            }
            if (typeof field === "string") {
              // const textAlign = col.title.toLowerCase().includes("asn_quantity")
              //   ? "right"
              //   : "center";
              <div style={{ textAlign: "center" }}>{value}</div>;
            }

            // Handle quantity highlighting
            if (
              field.startsWith("shortage_qty") ||
              field.startsWith("moq/mpq")
            ) {
              const highlightStyle =
                value > 0 ? { backgroundColor: "#FFD700" } : {};
              return <div style={highlightStyle}>{value}</div>;
            }

            // Handle different input types
            if (col.type === "text" || col.type?.startsWith("text")) {
              return (
                <TextBoxField
                  field={field}
                  id={col.name}
                  name={col.name}
                  label={col.title}
                  shrink={true}
                  readOnly={col.readOnly}
                  value={col.value?.key[row.original[col.value?.value]]}
                  onChange={(parameter) => {
                    col.onChange(parameter, row.original);
                  }}
                  onBlur={
                    col.onBlur &&
                    ((parameter) => {
                      col.onBlur(parameter, row.original);
                    })
                  }
                />
              );
            }

            // Handle date fields
            if (col.type === "date") {
              return (
                <DateField
                  field={field}
                  id={col.name}
                  name={col.name}
                  label={col.title}
                  shrink={true}
                  value={col.value?.key[row.original[col.value?.value]]}
                  onChange={(parameter) => {
                    col.onChange(parameter, row.original);
                  }}
                />
              );
            }

            // Handle file upload
            if (col.type === "upload") {
              return (
                <div>
                  {!imageSrc?.[`${field}-${row.original.id}`] && (
                    <div>
                      <label htmlFor={`upload-${field}-${row.original.id}`}>
                        <FileUploadOutlinedIcon style={{ cursor: "pointer" }} />
                      </label>
                      <input
                        type='file'
                        id={`upload-${field}-${row.original.id}`}
                        style={{ display: "none" }}
                        accept='image/*'
                        onChange={(event) => {
                          const file = event.target.files[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onload = (e) => {
                              setImageSrc((prevImages) => ({
                                ...prevImages,
                                [`${field}-${row.original.id}`]:
                                  e.target.result,
                              }));
                            };
                            reader.readAsDataURL(file);
                          }
                        }}
                      />
                    </div>
                  )}
                  {imageSrc?.[`${field}-${row.original.id}`] && (
                    <div style={{ position: "relative" }}>
                      <img
                        src={imageSrc?.[`${field}-${row.original.id}`]}
                        alt='Uploaded'
                        style={{ width: "100px", height: "100px" }}
                      />
                      <button
                        onClick={() => {
                          setImageSrc((prevImages) => ({
                            ...prevImages,
                            [`${field}-${row.original.id}`]: null,
                          }));
                        }}
                        style={{
                          position: "absolute",
                          marginBottom: "1px",
                          left: "30px",
                          backgroundColor: "transparent",
                          border: "none",
                          cursor: "pointer",
                        }}>
                        <ClearIcon />
                      </button>
                    </div>
                  )}
                </div>
              );
            }

            if (col.type === "view_image") {
              return <ImageIcon onClick={() => col.onClick(row)} />;
            }
            if (col.type === "addOrDelete") {
              // console.log(row, "rowmddd");
              // console.log(col, "colmddd");
              return row.original.isDelete ? (
                <HideSourceIcon
                  sx={{ marginTop: "14px" }}
                  onClick={() => col.onClick(row, "delete")}
                />
              ) : (
                <AddToPhotosIcon
                  sx={{ marginTop: "14px" }}
                  onClick={() => col.onClick(row, "add")}
                />
              );
            }
            if (col.type === "change_bin") {
              if (row?.original.ischange === true) {
                return (
                  <Button
                    variant='contained'
                    style={buttonStyles}
                    //  sx={{ width: "1px" }}
                    onClick={() => col.onClick(row)}>
                    <Battery0BarIcon />
                  </Button>
                );
              }
              return null;
            }
            if (col.type === "change_location") {
              if (row?.original.ischange === true) {
                return (
                  <Button
                    variant='contained'
                    style={buttonStyles}
                    // sx={{ width: "1px" }}
                    onClick={() => col.onClick(row)}>
                    <PrecisionManufacturingIcon />
                  </Button>
                );
              }
              return null;
            }
            if (col.type === "assign") {
              //if (params.row?.[e.hidden]) {
              return (
                <Button
                  variant='contained'
                  style={buttonStyles}
                  sx={{ padding: "2px" }}
                  onClick={() => col.onClick(row)}>
                  Assign
                </Button>
              );
              //}
              //return null;
            }
            if (col.type === "delete") {
              return <DeleteIcon />;
            }
            if (field === "input" && col.type === "checkbox") {
              // console.log(col, "col");
              // console.log(row, "row");
              // console.log(cell, "cell");
              return (
                <CheckboxField
                  checked={Boolean(
                    col?.value?.key?.[row?.original?.[col?.value?.value]]
                  )}
                  onChange={(event) => {
                    const newCheckedState = event.target.checked;
                    const activityId = row?.original?.[col?.value?.value];

                    // console.log("New Checked State:", newCheckedState);
                    // console.log("Row Data:", row.original);
                    // console.log("Activity ID:", activityId);

                    if (!col?.value?.key) {
                      console.error("col.value.key is undefined!");
                      return;
                    }

                    // Update the checkbox state in col.value.key
                    col.value.key[activityId] = newCheckedState;

                    // Ensure col.onChange exists before calling
                    if (typeof col.onChange === "function") {
                      col.onChange(newCheckedState, row);
                    } else {
                      console.error("col.onChange is not a function!");
                    }
                  }}
                />
              );
            }
            // Handle status fields
            if (field === "status" || field.toLowerCase().includes("status")) {
              const getStatusStyle = (value) => ({
                padding: "4px 8px 4px 8px",
                backgroundColor:
                  value === "Active" || value === "true" || value === "Approved"
                    ? "#E9F6ED"
                    : "#F6EFE9",
                color:
                  value === "Active" || value === "true" || value === "Approved"
                    ? "#24A148"
                    : "#DD7533",
                borderRadius: "4px",
              });

              return <div style={getStatusStyle(value)}>{value}</div>;
            }
            if (field === "input" && col.type === "multiselect") {
              if (Array.isArray(col.valueOptions)) {
                const selectedValues =
                  col.value.key[row?.original?.[col.value.value]] || [];

                return (
                  <MultiSelectField
                    key={col.name}
                    id={col.name}
                    name={col.name}
                    label={col.title}
                    shrink={true}
                    readOnly={col.field === "printername"}
                    value={selectedValues}
                    options={col.valueOptions}
                    onChange={(parameter) => {
                      col.onChange(parameter, row);
                    }}
                  />
                );
              }
            }
            if (
              ["input", "input1", "input2", "input3", "printername"].includes(
                field
              ) &&
              col.type === "singleSelect"
            ) {
              if (Array.isArray(col.valueOptions)) {
                return (
                  <SelectField
                    {...field}
                    key={col.name}
                    id={col.name}
                    name={col.name}
                    label={col.title}
                    shrink={true}
                    readOnly={col.field === "printername"}
                    value={col.value.key[row?.original?.[col.value.value]]}
                    options={
                      col.dynamicValueOption
                        ? col.dynamicValueOption(row)
                        : col.valueOptions
                    }
                    onChange={(parameter) => {
                      col.onChange(parameter, row);
                    }}
                  />
                );
              }
            }
            if (field.startsWith("status") && col.type === "singleSelect") {
              if (Array.isArray(col.valueOptions)) {
                return (
                  <SelectField
                    {...field}
                    id={col.name}
                    name={col.name}
                    label={col.title}
                    value={col.value.key[row[col.value.value]]}
                    options={col.valueOptions}
                    onChange={(parameter) => {
                      col.onChange(parameter, row);
                    }}
                  />
                );
              }
            }
            if (field.startsWith("input") && col.type === "autoComplete") {
              if (Array.isArray(col.valueOptions)) {
                return (
                  <AutoCompleteField
                    {...field}
                    id={col.name}
                    size='small'
                    options={col.valueOptions}
                    getOptionLabel={(option) => option.label}
                    value={
                      col.valueOptions.find(
                        (option) =>
                          option.value === col.value.key[row?.[col.value.value]]
                      ) || null
                    }
                    onChange={(event, value) => {
                      col.onChange(value, row);
                    }}
                    renderInput={(row) => (
                      <TextField
                        {...row}
                        label={col.title}
                        variant='outlined'
                        name={col.name}
                      />
                    )}
                  />
                );
              }
            }
            if (
              field.startsWith("input1") &&
              col.type === "autoCompleteField"
            ) {
              if (Array.isArray(col.valueOptions)) {
                return (
                  <AutoCompleteField
                    {...field}
                    id={col.name}
                    size='small'
                    options={col.valueOptions}
                    getOptionLabel={(option) => option.label}
                    value={
                      col.valueOptions.find(
                        (option) =>
                          option.value === col.value.key[row?.[col.value.value]]
                      ) || null
                    }
                    onChange={(event, value) => {
                      col.onChange(value, row);
                    }}
                    renderInput={(row) => (
                      <TextField
                        {...row}
                        label={col.title}
                        variant='outlined'
                        name={col.name}
                      />
                    )}
                  />
                );
              }
            }
            // if (field.startsWith("action") && col.type === "singleSelect") {
            //   if (Array.isArray(col.valueOptions)) {
            //     return (
            //       <SelectField
            //         {...field}
            //         id={col.name}
            //         name={col.name}
            //         label={col.title}
            //         value={col.value.key[row[col.value.value]]}
            //         options={col.valueOptions}
            //         onChange={(parameter) => {
            //           col.onChange(parameter, row);
            //         }}
            //       />
            //     );
            //   }
            // }
            if (field === "gate_status") {
              const statusStyle = {
                padding: "4px 8px 4px 8px",
                backgroundColor:
                  value === "Gate In"
                    ? "#E9F6ED"
                    : value === "Gate Out"
                    ? "#F6EFE9"
                    : "#FF974C",
                color:
                  value === "Gate In"
                    ? "#24A148"
                    : value === "Gate Out"
                    ? "#DD7533"
                    : "#000000",
                borderRadius: "4px",
              };

              return (
                <div style={statusStyle}>
                  {value === "Gate In"
                    ? "Gate In"
                    : value === "Gate Out"
                    ? "Gate Out"
                    : "Loaded"}
                </div>
              );
            }
            if (field === "attendance_status") {
              const statusStyle = {
                padding: "4px 8px 4px 8px",
                backgroundColor:
                  value === "Approved"
                    ? "#E9F6ED"
                    : value === "In Progress"
                    ? "#F6EFE9"
                    : "#FF974C",
                color:
                  value === "Approved"
                    ? "#24A148"
                    : value === "In Progress"
                    ? "#DD7533"
                    : "#000000",
                borderRadius: "4px",
              };

              return (
                <div style={statusStyle}>
                  {value === "Approved"
                    ? "Approved"
                    : value === "In Progress"
                    ? "In Progress"
                    : "In Progress"}
                </div>
              );
            }
            if (field === "status") {
              const statusStyle = {
                padding: "4px 8px 4px 8px",
                backgroundColor:
                  value === "Active"
                    ? "#E9F6ED"
                    : value === "Inactive"
                    ? "#F6EFE9"
                    : "#FF974C",
                color:
                  value === "Active"
                    ? "#24A148"
                    : value === "Inactive"
                    ? "#DD7533"
                    : "#000000",
                borderRadius: "4px",
              };

              return (
                <div style={statusStyle}>
                  {value === "Active"
                    ? "Active"
                    : value === "Inactive"
                    ? "Inactive"
                    : "Draft"}
                </div>
              );
            }
            if (
              field.toLowerCase() === "status1" ||
              field.toLowerCase() === "hidden_status1" ||
              field === switchParams?.key
            ) {
              const statusStyle = {
                padding: "4px 8px 4px 8px",
                backgroundColor:
                  value === "Approved" || value === "true"
                    ? "#E9F6ED"
                    : "#F6EFE9",
                color:
                  value === "Approved" || value === "true"
                    ? "#24A148"
                    : "#DD7533",
                borderRadius: "4px",
              };

              return (
                <div style={statusStyle}>
                  {value === "Approved" || value === "true"
                    ? "Approved"
                    : value === "Rejected" || value === "false"
                    ? "Rejected"
                    : "Pending"}
                </div>
              );
            }
            if (
              field.toLowerCase() === "status" ||
              field.toLowerCase() === "hidden_status" ||
              field === switchParams?.key
            ) {
              const statusStyle = {
                padding: "4px 8px 4px 8px",
                backgroundColor:
                  value === "Active" || value === "true"
                    ? "#E9F6ED"
                    : "#F6EFE9",
                color:
                  value === "Active" || value === "true"
                    ? "#24A148"
                    : "#DD7533",
                borderRadius: "4px",
              };

              return (
                <div style={statusStyle}>
                  {value === "Active" || value === "true"
                    ? "Active"
                    : value === "Inactive" || value === "false"
                    ? "Inactive"
                    : "Draft"}
                </div>
              );
            }

            // Default case
            return value;
          },
        };

        return baseColumn;
      })
      .filter(Boolean);
  }, [columns, imageSrc, setImageSrc]);
  const [rowSelection, setRowSelection] = useState({});
  useEffect(() => {
    console.log("selectedData : ", selectedData);
  }, [selectedData]);

  useEffect(() => {
    console.log("row selection: ", rowSelection);

    // Extract selected row indexes (keys where value is true)
    const selectedIndexes = Object.keys(rowSelection)
      .filter((key) => rowSelection[key]) // Keep only selected rows
      .map((key) => Number(key)); // Convert string keys to numbers

    // Map indexes to actual row data
    const newSelectedData = selectedIndexes.map((index) => dataWithId[index]);

    // Check if setSelectedData is passed as a prop before calling it
    if (typeof setSelectedData === "function") {
      setSelectedData(newSelectedData);
    } else {
      console.warn("setSelectedData is not provided as a prop.");
    }
  }, [rowSelection]); // Update when rowSelection changes
  const renderToolbarActions = () => {
    if (toolbar?.create) {
      return (
        <Button
          color='primary'
          onClick={toolbar.onCreateClick}
          variant='contained'
          startIcon={<AddIcon />}>
          Create
        </Button>
      );
    }
    return null;
  };
  return (
    <MaterialReactTable
      columns={processColumns}
      data={dataWithId}
      enableRowActions={Boolean(actions)}
      enableRowSelection={Boolean(selection)}
      onRowSelectionChange={setRowSelection}
      state={{ rowSelection }}
      positionActionsColumn={actions ? positionActionsColumn : undefined}
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableColumnFilters
      localization={{
        filterMode: "",
      }}
      editingMode='modal'
      enableEditing
      renderTopToolbarCustomActions={renderToolbarActions}
      renderRowActions={
        
           ({ row }) => (
              <Box sx={{ display: "flex", gap: "0.5rem" }}>
                {onView && (
                  <IconButton
                    onClick={() => onView(row.original)}
                    color='info'
                    size='small'>
                    <VisibilityIcon />
                  </IconButton>
                )}
                {onEdit && (
                  <IconButton
                    onClick={() => onEdit(row.original)}
                    color='primary'
                    size='small'>
                    <EditIcon />
                  </IconButton>
                )}
                {onSwitch && (
                  <Switch
                    checked={
                      row.original[switchParams.key] === switchParams.value
                    }
                    onChange={() => onSwitch(row.original)}
                    size='small'
                  />
                )}
              </Box>
            )
          
      }
      enablePagination={true}
      positionToolbarAlertBanner='bottom'
      positionGlobalFilter='left'
      positionPagination='bottom'
      enableGlobalFilter={true}
      enableColumnFiltering={true}
      enableDensityToggle={true}
      enableFullScreenToggle={true}
      enableHiding={true}
      enableColumnActions={true}
      enableStickyHeader={true}
      enableToolbarInternalActions={true}
      muiTableContainerProps={{
        sx: {
          height: "400px",
          maxHeight: "400px",
          overflowX: "auto", // Ensure horizontal scroll is enabled
          "&::-webkit-scrollbar": {
            height: "8px", // Adjust scrollbar height
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#E0E0E0", // Track color
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#C0C0C0", // Thumb color (scroll handle)
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#A8A8A8", // Thumb hover color
          },
        },
      }}
      muiTopToolbarProps={{
        sx: {
          display: "flex",
          backgroundColor: "#EDF3FF",
          alignItems: "center",
          minHeight: "50px",
          maxHeight: "50px",
          padding: "0 6px",
          gap: "8px",
          backgroundColor: "none",
          // marginTop: "10px",
          "& .MuiBox-root": {
            display: "flex",
            alignItems: "center",
            gap: "8px",
            //marginTop: "10px",
          },
          "& > div": {
            display: "inline-flex",
            alignItems: "center",
          },
          "& .MuiInputBase-root": {
            height: "50px",
            maxWidth: "200px",
          },
          "& > div:first-of-type": {
            flex: "1",
            display: "flex",
            gap: "8px",
            "& > button": {
              padding: "4px",
            },
          },
          "& > div:last-child": {
            marginLeft: "auto",
          },
          '& [title="Toggle Density"]': {
            display: "none",
          },
          '& [title="Toggle Full Screen"]': {
            display: "none",
          },
          '& [title="Show/Hide Columns"]': {
            display: "none",
          },
        },
      }}
      muiTableBodyCellProps={{
        sx: {
          padding: "8px",
          fontSize: "12px",
          fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
          ].join(","),
        },
      }}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "#C0C0C0",
          color: "black",
          fontSize: "12px",
          minHeight: "30px !important",
          height: "30px !important",
          textAlign: "center",
          fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
          ].join(","),
        },
      }}
      muiTableBodyRowProps={{
        sx: {
          "&:nth-of-type(odd)": {
            backgroundColor: (theme) =>
              theme.palette.mode === "light" ? "#fafafa" : "#1d1d1d",
          },
        },
      }}
      muiTableHeadCellFilterTextFieldProps={{
        sx: { m: "0.5rem 0", width: "100%" },
        variant: "outlined",
        size: "small",
      }}
      muiTablePaginationProps={{
        rowsPerPageOptions: [10, 20, 50, 100],
        showFirstButton: true,
        showLastButton: true,
        component: "div",
        sx: {
          display: "flex",
          alignItems: "center",
          gap: "8px",
          "& .MuiTablePagination-toolbar": {
            paddingLeft: 0,
            minHeight: "30px",
            maxHeight: "30px",
          },
          "& .MuiTablePagination-selectLabel": {
            margin: 0,
          },
          "& .MuiTablePagination-select": {
            marginRight: "8px",
          },
          "& .MuiTablePagination-displayedRows": {
            margin: 0,
          },
          "& .MuiTablePagination-actions": {
            marginLeft: "8px",
          },
        },
      }}
      initialState={{
        density: "compact",
        showColumnFilters: true,
        pagination: { pageSize: 10, pageIndex: 0 },
      }}
    />
  );
};
export default MaterialTable;
